import boletaApi from "./boletaApi";

export const updateInteresMes = async (body) => {
  try {
    return await boletaApi.post("/udpateInteresMes", body);
  } catch (error) {
    const { response } = error;
    return response;
  }
};
